import { gql } from "@apollo/client";

// Surveys (see wfc-server resolvers/surveyResolver). submitSurveyByToken is public.

export const updateSurveySettingsMutation = gql`
    mutation updateSurveySettings($input: SurveySettingsInput!){
        updateSurveySettings(input: $input){
            message
            response
        }
    }
`;

export const saveSurveyTemplateMutation = gql`
    mutation saveSurveyTemplate($input: AppraisalTemplateInput!){
        saveSurveyTemplate(input: $input){
            message
            response
        }
    }
`;

export const archiveSurveyTemplateMutation = gql`
    mutation archiveSurveyTemplate($id: String!, $archived: Boolean){
        archiveSurveyTemplate(id: $id, archived: $archived){
            message
            response
        }
    }
`;

export const sendSurveyMutation = gql`
    mutation sendSurvey($input: SendSurveyInput!){
        sendSurvey(input: $input){
            message
            response
        }
    }
`;

export const stopSurveyScheduleMutation = gql`
    mutation stopSurveySchedule($id: String!){
        stopSurveySchedule(id: $id){
            message
            response
        }
    }
`;

export const remindSurveyMutation = gql`
    mutation remindSurvey($id: String!){
        remindSurvey(id: $id){
            message
            response
        }
    }
`;

export const closeSurveyMutation = gql`
    mutation closeSurvey($id: String!){
        closeSurvey(id: $id){
            message
            response
        }
    }
`;

export const exportSurveyResultsMutation = gql`
    mutation exportSurveyResults($id: String!, $format: String){
        exportSurveyResults(id: $id, format: $format){
            message
            response
        }
    }
`;

export const submitMySurveyMutation = gql`
    mutation submitMySurvey($responseId: String!, $answers: JSON!, $signature: String, $typedName: String){
        submitMySurvey(responseId: $responseId, answers: $answers, signature: $signature, typedName: $typedName){
            message
            response
        }
    }
`;

export const submitSurveyByTokenMutation = gql`
    mutation submitSurveyByToken($token: String!, $answers: JSON!, $signature: String, $typedName: String){
        submitSurveyByToken(token: $token, answers: $answers, signature: $signature, typedName: $typedName){
            message
            response
        }
    }
`;

export const submitOurSideSurveyMutation = gql`
    mutation submitOurSideSurvey($responseId: String!, $answers: JSON!, $signature: String, $typedName: String){
        submitOurSideSurvey(responseId: $responseId, answers: $answers, signature: $signature, typedName: $typedName){
            message
            response
        }
    }
`;

// "What we did" on a survey's results
export const addSurveyActionMutation = gql`
    mutation addSurveyAction($id: String!, $text: String!){
        addSurveyAction(id: $id, text: $text){
            message
            response
        }
    }
`;

export const removeSurveyActionMutation = gql`
    mutation removeSurveyAction($id: String!, $actionId: String!){
        removeSurveyAction(id: $id, actionId: $actionId){
            message
            response
        }
    }
`;

// one person's answers written into the company's own form (PDF)
export const getSurveyResponseFormMutation = gql`
    mutation getSurveyResponseForm($responseId: String!){
        getSurveyResponseForm(responseId: $responseId){
            message
            response
        }
    }
`;

// the company's own form as a template: upload, then prepare
export const getSurveyTemplateUploadUrlMutation = gql`
    mutation getSurveyTemplateUploadUrl($fileName: String!){
        getSurveyTemplateUploadUrl(fileName: $fileName){
            message
            response
        }
    }
`;

export const prepareSurveyTemplatePdfMutation = gql`
    mutation prepareSurveyTemplatePdf($key: String!, $fileName: String!){
        prepareSurveyTemplatePdf(key: $key, fileName: $fileName){
            message
            response
        }
    }
`;
